module.exports = __webpack_public_path__ + "static/media/tracy_05.eb9f14cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/album/tracy_05.jpg
// module id = 383
// module chunks = 0